import React, { useEffect, useState } from 'react';
import * as CounterStore from './CounterStore';
import './App.css';
import useForceUpdate from 'use-force-update';
var Counter = function () {
    var counter = CounterStore.store.state.counter;
    var forceUpdate = useForceUpdate();
    useEffect(function () {
        var unsubscribe = CounterStore.store.subscribe(function () { return forceUpdate(); });
        console.log("subscribe");
        return function () {
            console.log("unsubscribe");
            unsubscribe();
        };
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("h1", null, counter),
        React.createElement("button", { onClick: function () { return CounterStore.increase(); } }, "+ 1"),
        React.createElement("button", { className: "asyncButton", onClick: function () { return CounterStore.increaseAsync(); } }, "+ 1 Async")));
};
function App() {
    var _a = useState(false), hide = _a[0], setHide = _a[1];
    var handleButton = function () {
        setHide(!hide);
    };
    return (React.createElement("div", { className: "App" },
        React.createElement("h1", null, "Counter App"),
        React.createElement("div", { className: "action-bar" },
            React.createElement("button", { className: "subscribe-button", onClick: handleButton }, hide ? "Subscribe" : "Unsubscribe")),
        !hide && React.createElement(Counter, null)));
}
export default App;
